import { useEffect, useState } from "react";
import settings from "../utils/settings";
const useStatTotalTrans = (periodType, fromDate, toDate) => {
  const [totalTrans, setTotalTrans] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  useEffect(() => {
    const getTotalRevenue = async () => {
      const { token, branchId } = settings();
      let urlBranch = "";
      if (branchId) urlBranch = `&branch_id=${branchId}`;
      try {
        const result = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/stat/total-trans?period_type=${periodType}&from=${fromDate}&to=${toDate}${urlBranch}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        const jsonResult = await result.json();

        setTotalTrans(jsonResult.payload);

        return setLoading(false);
      } catch (error) {
        setError(error);
        return setLoading(false);
      }
    };
    getTotalRevenue();
  }, [periodType, fromDate, toDate]);
  return { totalTrans, loading, error };
};

export default useStatTotalTrans;
